import { types, type Instance } from 'mobx-state-tree';
import ObjectType from '../metamodel/object_type';
import { modelReference } from '../refHelper';

const DEFAULT_WIDTH = 100;
const DEFAULT_HEIGHT = 50;
const DEFAULT_X = 0;
const DEFAULT_Y = 0;

/**
 * A node in an EDG. This is the visual counterpart of an object type. It has a
 * position (x, y) and a size (width, height).
 *
 * For the references to the object type, we don't use types.reference directly,
 * but our custom wrapper. See '../refHelper.js' for the reason why.
 */
const Node = types
  .model('Node', {
    objectType: modelReference<typeof ObjectType>(ObjectType),
    position: types.optional(
      types.model({
        x: types.number,
        y: types.number,
      }),
      () => ({ x: DEFAULT_X, y: DEFAULT_Y })
    ),
    size: types.optional(
      types.model({
        height: types.number,
        width: types.number,
      }),
      () => ({ width: DEFAULT_WIDTH, height: DEFAULT_HEIGHT })
    ),
  })
  .views(self => ({
    get center() {
      return {
        x: self.position.x + self.size.width / 2,
        y: self.position.y + self.size.height / 2,
      };
    },
  }))
  .actions(self => ({
    updatePosition(x: number, y: number) {
      self.position.x = x;
      self.position.y = y;
    },
    updateSize(width: number, height: number) {
      self.size.width = width;
      self.size.height = height;
    },
  }));

export type INode = Instance<typeof Node>;

export default Node;
